export interface ICharacterLevelUpStat {
	code: number;
	name: string;
	maxHp: number;
	maxSp: number;
	attackPower: number;
	defense: number;
	criticalChance: number;
	hpRegen: number;
	spRegen: number;
	attackSpeed: number;
	moveSpeed: number;
}
